import React, { Component } from "react";
import { Button, Input, Table, Modal, Select, message, Alert } from 'antd';
import styled from 'styled-components';
import StoreAPI from '@/api/store';
import utils from '@/utils/auth';
import moment from 'moment';
const { Search } = Input;
const Container = styled.div`
  .search-wrapper {
    display: flex;
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
    .auth-alert {
      margin-left: 40px;
    }
  }
`;
const ModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    align-items: center;
    height: 40px;
    .label {
      position: relative;
      width: 100px;
      white-space: nowrap;
      &.required::before {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
      &::after {
        content:"";
        width: 100%;
        overflow: hidden;
        height: 0;
      }
    }
    .value {
      width: 200px;
    }
  }
`;
export default class StoreMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        keyword: '',
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      storeList: [],

      isVisible: false,
      itemInfo: {},
      mtStoreList: [],
      storeAuthorizationStatus: null,
    };
  }

  componentDidMount() {
    this.queryStoreMappingList();
    this.queryStoreAuthStatus();
  }

  queryStoreMappingList = () => {
    const { searchParams } = this.state;
    StoreAPI.queryStoreMappingList(searchParams)
        .then(({ items: storeList, paginator }) => {
          const { totalCount: total } = paginator;
          this.setState({ storeList, total });
      });
  }

  queryStoreAuthStatus = () => {
    StoreAPI.queryStoreAuthorizationStatus()
      .then(storeAuthorizationStatus => {
        let { validityPeriod, remainRefreshCount = 0 } = storeAuthorizationStatus;
        let deadline = validityPeriod || '';
        if (remainRefreshCount !== null && remainRefreshCount > 0) {
          const d = deadline ? new Date(deadline) : new Date();
          const month = d.getMonth();
          d.setMonth(remainRefreshCount + month);
          deadline = moment(d).format('YYYY-MM-DD HH:mm:ss');
        }
        this.setState({ storeAuthorizationStatus: Object.assign({}, storeAuthorizationStatus, { deadline }) });
      });
  }

  onSearch = () => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: 1 }) }, this.queryStoreMappingList);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.queryStoreMappingList);
  }

  initMtStoreList = () => {
    StoreAPI.queryMtStoreList()
      .then(mtStoreList => {
        this.setState({ mtStoreList });
      });
  }

  showModal = item => {
    this.setState({ isVisible: true, itemInfo: Object.assign({}, item) }, this.initMtStoreList);
  }

  modalConfirm = () => {
    const { itemInfo } = this.state;
    const { kdtId, opPoiId, opPoiName } = itemInfo;
    if (!opPoiId) return message.warning('请选择美团店铺');
    StoreAPI.shopMappingBind({ kdtId, opPoiId, opPoiName })
        .then(res => {
          this.setState({ isVisible: false }, this.queryStoreMappingList);
        });

  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const { searchParams, storeList, total, isVisible, itemInfo, mtStoreList, storeAuthorizationStatus } = this.state;
    const columns = [
      {
        title: '有赞店铺名称',
        dataIndex: 'kdtName',
        key: 'kdtName'
      },
      {
        title: '有赞店铺ID',
        dataIndex: 'kdtId',
        key: 'kdtId'
      },
      {
        title: '美团店铺名称',
        dataIndex: 'opPoiName',
        key: 'opPoiName'
      },
      {
        title: '美团店铺ID',
        dataIndex: 'opPoiId',
        key: 'opPoiId'
      },
      {
        title: '操作',
        render: item => <Button type="link" disabled={!status} onClick={() => this.showModal(item)}>编辑</Button>
      }
    ];

    return (
      <Container>
        <div className="search-wrapper">
          <div className="search">
            <span className="label">店铺名称：</span>
            <Search
              allowClear
              enterButton="搜索"
              value={searchParams.keyword}
              placeholder="请输入店铺名称/ID"
              className="search-input"
              onSearch={this.onSearch}
              onChange={e => {
                const value = e.target.value;
                this.setState({ searchParams: Object.assign(searchParams, { keyword: value }) });
              }}
            />
          </div>

          {
            storeAuthorizationStatus && <Alert
                className="auth-alert"
                type={storeAuthorizationStatus.status === 1 ? 'error' : 'success'}
                closable
                showIcon
                message={storeAuthorizationStatus.status === 1 ? '温馨提示：您的美团店铺授权已过期，请尽快重新授权，避免美团接口调用失败' : `美团店铺授权有效期：${storeAuthorizationStatus.deadline}`}
                action={storeAuthorizationStatus.status === 1 && <Button type="link" href={storeAuthorizationStatus.url} target="_blank">立即前往授权</Button>}
            />
          }
        </div>

        <div className="content-wrapper">
          <Table
            rowKey="kdtId"
            columns={columns}
            dataSource={storeList}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              total,
              showTotal: total => `共${total}条`,
              hideOnSinglePage: false,
              onChange: this.onPageChange
            }}
          />
        </div>

        <Modal
          title="门店映射"
          open={isVisible}
          maskClosable={false}
          onOk={this.modalConfirm}
          onCancel={() => this.setState({ isVisible: false })}
        >
          <ModalWrapper>
            <div className="item">
              <div className="label">有赞店铺名称：</div>
              <div className="value">{itemInfo.kdtName}</div>
            </div>
            <div className="item">
              <div className="label">有赞店铺ID：</div>
              <div className="value">{itemInfo.kdtId}</div>
            </div>
            <div className="item">
              <div className="label required">美团店铺：</div>
              <div className="value">
                <Select
                  allowClear
                  showSearch
                  style={{ width: 200 }}
                  value={itemInfo.opPoiId}
                  optionFilterProp="name"
                  fieldNames={{
                    label: 'name',
                    value: 'opPoiId'
                  }}
                  options={mtStoreList}
                  onChange={value => {
                    const { opPoiId: opPoiId, name: opPoiName } = mtStoreList.find(o => o.opPoiId === value) || {};
                    this.setState({ itemInfo: Object.assign({}, itemInfo, { opPoiId, opPoiName }) });
                  }}
                />
              </div>
            </div>
          </ModalWrapper>
        </Modal>
      </Container>
    );
  }
}
